import { DEFAULT_PHONE_CODE } from '$app/constants/common'
import { z } from 'zod'

const trimmedString = z.string().trim()

export const schema = z.object({
  password: trimmedString.min(1, 'Required'),
  phone_no: trimmedString.min(1, 'Required'),
  phone_code: z.string()
})

export type TField = z.infer<typeof schema>

export const DEFAULT_FORM_VALUES: TField = {
  password: '',
  phone_code: DEFAULT_PHONE_CODE,
  phone_no: ''
}
